import type { RouteRecordRaw } from 'vue-router'
import { TablePostPage } from '@myorg/lib2-tailwindcss'
import { ROUTES } from '@myorg/type-lib'
import { logger } from '@myorg/type-lib';

export class TableApiMock implements TableApi {
  async getTables(): Promise<Table[]> {
    logger.log("使用 Mock API 獲取資料...");
    return [
      { id: '1', name: 'A-01 窗邊', status: '空位' },
      { id: '2', name: 'B-05 包廂', status: '使用中' },
      { id: '3', name: 'C-02 大桌', status: '已預約' }
    ];
  }
  async updateTable(id: string, data: Partial<Table>) {
    logger.log(`Mock 更新桌位 ${id}:`, data);
  }
}

// 建立一個實體
const inventoryApi = new TableApiMock();

export const inventoryRoute2: RouteRecordRaw = {
  path: ROUTES.INVENTORY2.PATH,
  name: ROUTES.INVENTORY2.NAME,
  component: TablePostPage,
  // 簡化傳遞
  props: { api: inventoryApi } 
}
